// (async () => {
//     const baseComponent = await import(window.theme.modules.baseComponent);
  
//     customElements.define('product-variant-selector', class extends baseComponent.default {

//         render() {
//             this.addEventListener('change', this._variantChangeHandler.bind(this));
//         }

//         _variantChangeHandler(e) {
//             this.forwardEvent('variantChange', {
//                 optionValueId: e.target.dataset.optionValueId, 
//                 optionIndex: e.target.dataset.optionIndex,
//                 variantId: e.target.dataset.variantId,
//                 imagePosition: e.target.dataset.imagePosition
//             })
//         }  
//     });
//   })();

(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  function getProductData() {
    const productId = window.meta?.product?.id;
    const el = document.getElementById('ProductJson-' + productId);
    if (el) {
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('Error parsing product JSON:', e);
      }
    }
    return null;
  }

  customElements.define('product-variant-selector', class extends baseComponent.default {
    render() {
      this.addEventListener('change', this._variantChangeHandler.bind(this));
    }

    _variantChangeHandler(e) {
      const variantId = parseInt(e.target.dataset.variantId, 10);

      this.forwardEvent('variantChange', {
        optionValueId: e.target.dataset.optionValueId,
        optionIndex: e.target.dataset.optionIndex,
        variantId: variantId,
        imagePosition: e.target.dataset.imagePosition
      });

      const product = getProductData();
      if (!product || !Array.isArray(product.variants)) return;

      const variant = product.variants.find(v => v.id === variantId);
      if (!variant) return;

      const priceEl = document.querySelector('.pre-money');
    const compareEl = document.querySelector('.bold-pre-compare-price');

 if (priceEl) {
        priceEl.textContent = variant.price;
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price;
          compareEl.style.display = 'inline';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (typeof BOLD?.pre?.events?.emit === 'function') {
        BOLD.pre.events.emit("variant_changed", { variant });
      }
    }
  });
})();